import React, { useEffect, useState } from 'react';
import { Plus, X, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const PaymentMethodsSettings = ({ api }) => {
  const [methods, setMethods] = useState([]);
  const [draft, setDraft] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => { api().get('/payment-methods').then(r => setMethods(r.data.methods || [])).catch(() => {}); }, [api]);

  const add = () => {
    const v = draft.trim();
    if (!v || methods.includes(v)) return;
    setMethods([...methods, v]); setDraft('');
  };
  const save = async () => {
    setSaving(true);
    try { const r = await api().put('/admin/payment-methods', { methods }); setMethods(r.data.methods); toast.success('Payment methods saved'); }
    catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); } finally { setSaving(false); }
  };

  return (
    <Card className="industrial-card" data-testid="payment-methods-card">
      <CardHeader className="border-b border-slate-100 pb-3"><CardTitle className="text-lg">Payment Methods</CardTitle></CardHeader>
      <CardContent className="p-4 space-y-3">
        <p className="text-sm text-slate-500">Choices shown when recording a payment on a Sales Order.</p>
        <div className="flex flex-wrap gap-2">
          {methods.map(m => (
            <span key={m} className="inline-flex items-center gap-1 bg-slate-100 border border-slate-200 rounded-sm px-2 py-1 text-sm" data-testid={`payment-method-chip-${m}`}>
              {m}
              <button type="button" onClick={() => setMethods(methods.filter(x => x !== m))} className="text-slate-500 hover:text-red-600" data-testid={`payment-method-remove-${m}`}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
        <div className="flex gap-2">
          <Input value={draft} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && add()} placeholder="Add method (e.g. PayPal)" className="w-64 rounded-sm" data-testid="payment-method-input" />
          <Button variant="outline" onClick={add} className="rounded-sm" data-testid="payment-method-add-btn"><Plus className="w-4 h-4 mr-1" /> Add</Button>
          <Button onClick={save} disabled={saving || !methods.length} className="bg-slate-900 hover:bg-slate-800 rounded-sm" data-testid="payment-methods-save-btn"><Save className="w-4 h-4 mr-1" /> Save</Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PaymentMethodsSettings;
